module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAYCAMAAAA4a6b0AAAAS1BMVEVHcEwaCjsbCzsbCzsbCzsaCjsbCzsbCzsbCzsbCzsbCjsbCzsbCzsaCjsbCzsXBzgbCzsaCTobCzsbCzsbCzsaCjsbCzsbCzsbCzuHSHL+AAAAGHRSTlMAD/Kg1RTtlPmJLWXLMUECwwdMVLIjdG0k8Ez+AAAAwklEQVQoz3VSWxKEIAwrr1ZcBHzv/U+6FEGdVfJjYjo00IL8JqAdoWK0yL8k+J2JnE7Hcy1uPlHFJSpUhy75YapNMURk+cm8z8f54gyscLhVbcXJJzhxCMtiOdKF3JVK2dRxozVzoxPv5tp0uZrOXBVrnLCS01r1DNLaqf68HARhjLGISOkrAvyBgyh4w6sTRIKVKMkkcjNWik6rISElcJHOBO3U7Zs2X6f9ou0ptCd3TBse035syJQ3ZPeQt0q+bNUPNEETzfAJaYcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Mixpanel_Symbol.png
// module id = 2059
// module chunks = 0